import React from "react";

export const Marquee = ({ items }) => {
    return (
        <div className="relative w-full overflow-hidden border-y border-white/5 py-5 bg-[#0A0A0A]">
            <div className="flex whitespace-nowrap animate-marquee">
                {[...items, ...items].map((it, i) => (
                    <div key={`${it}-${i}`} className="flex items-center gap-12 px-6 text-brutal text-sm text-[#A3A3A3]">
                        <span>{it}</span>
                        <span className="text-[#591C1C]">✦</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
